import React, {useState} from 'react';
import PropTypes from 'prop-types';

import Checkbox from "../Checkbox";
import './multiple_selector.scss';

const uniq_id = 'multiple-selector-' + Date.now() + '-' + Math.floor(Math.random() * 100);

function MultipleSelector(
    {
        item_id_key = 'id',
        item_name,
        trigger,
        items,
        selected,
        callback,
        className,
        disabled = false,
        showCloseButton = true,
        showAllOption = true,
        matchDropdownWidth = true,
        allowHtml = false
    }
) {
    const [show, setShow] = useState(false);

    function onToggle() {
        if (!disabled) {
            setShow(!show);
        }
    }

    function onItemCheck(id) {
        return () => {
            let selected_new = [];
            if ('all' === id) {
                if (selected_new.length !== items.length) {
                    items.map(item => selected_new.push(item[item_id_key]));
                }
            } else {
                selected_new = JSON.parse(JSON.stringify(selected));
                if (selected_new.indexOf(id) < 0) {
                    selected_new.push(id);
                } else {
                    selected_new.splice(selected_new.indexOf(id), 1);
                }
            }
            callback(selected_new);
        }
    }

    function renderCloseButton() {
        if (showCloseButton) {
            return <button className='close-button' onClick={onToggle}/>;
        }

        return null;
    }

    function renderAllOption() {
        if (showAllOption) {
            return (
                <li className='all'>
                    <Checkbox
                        id={'item-all'}
                        checked={items.length === selected.length}
                        label={'All ' + item_name + 's'}
                        toggle={onItemCheck('all')}/>
                </li>
            );
        }

        return null;
    }

    return (
        <div
            className={"multiple-selector-container flex-row " + className}
            style={{position: 'relative'}}>
            <div className={"multiple-selector-trigger flex-row " + (disabled ? 'disabled' : '')}
                 onClick={onToggle}>
                {trigger}
            </div>
            <div
                id={uniq_id}
                className={"multiple-selector-content"}
                style={{
                    display: show ? 'block' : 'none',
                    right: matchDropdownWidth ? 0 : 'unset'
                }}
            >
                <div className='multiple-selector-content-box'>
                    {renderCloseButton()}
                    <ul className='multiple-selector-dropdown'>
                        {renderAllOption()}
                        {
                            items.map((item, key) => {
                                return (
                                    <li key={key}>
                                        <Checkbox
                                            id={'item-' + key}
                                            checked={selected.indexOf(item[item_id_key]) >= 0}
                                            label={item.label}
                                            toggle={onItemCheck(item[item_id_key])}
                                            allowHtml={allowHtml}/>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

MultipleSelector.propTypes = {
    item_id_key: PropTypes.string,
    item_name: PropTypes.string.isRequired,
    trigger: PropTypes.element.isRequired,
    items: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    callback: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    showAllOption: PropTypes.bool,
    matchDropdownWidth: PropTypes.bool,
    allowHtml: PropTypes.bool
};

export default MultipleSelector;
